import { render, staticRenderFns } from "./resumo-profissionais.vue?vue&type=template&id=ac944cde&scoped=true"
import script from "./resumo-profissionais.vue?vue&type=script&lang=ts"
export * from "./resumo-profissionais.vue?vue&type=script&lang=ts"
import style0 from "./resumo-profissionais.vue?vue&type=style&index=0&id=ac944cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac944cde",
  null
  
)

export default component.exports